export default __webpack_public_path__ + "static/media/Carnival UK - P&O Cruises - Cunard-4.556467cf.png";